/**
 * Orders Page
 */
import React from 'react';
import Layout from '@/components/Layout';
import Orders from '../../containers/Orders';
import { checkForWrongDomain } from '../../utils/checkForWrongDomain';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { getRequiredCtxProps } from '../../utils/getRequiredCtxProps';
import { useSetSSRStore, useSSRSelector } from '../../redux';

const OrdersPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeData = useSSRSelector((state) => state.storeReducer.store);

  return (
    <Layout
      store={storeData}
      title={`Orders - Now Shop Online`}
      Icon={storeData?.store_info?.logo_image}
      metaDescription={
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGImage={storeData?.store_info?.logo_image}
    >
      <Orders />
    </Layout>
  );
};

/**
 * @param {import('next').NextPageContext} ctx
 * @returns {any}
 */
export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};

  let propData = {
    ssrStore: {},
    catalogCategories: [],
    catalogTags: [],
    collections: [],
  };

  const ssrPropData = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['theme', 'collections', 'categories', 'themeHtml', 'seo'],
  });

  propData = { ...propData, ...ssrPropData };

  const extraProps = getRequiredCtxProps(ctx, ssrPropData);

  return { props: { ...propData, ...extraProps } };
}

export default OrdersPage;
